import { stringify } from 'query-string';

import { TopicFilterNames } from 'components/TopicFilters/shared';
import getCountryIds from 'helpers/getCountryIds';

interface IPlaylistPositionsTrendURLArgs {
  countryIds?: string[];
  regionIds?: string;
  customerFilter?: TopicFilterNames[];
  entityIds: string;
  playlistIds: number;
  customRegion?: string | string[];
  regionBreakdown?: string;
}

export default function getPlaylistTrendURL(
  args: IPlaylistPositionsTrendURLArgs
): string {
  const {
    countryIds,
    regionIds,
    customerFilter,
    entityIds,
    playlistIds,
    customRegion,
    regionBreakdown,
  } = args;

  const params = stringify({
    countryIds: getCountryIds(countryIds, regionIds, customRegion),
    customerFilter,
    playlistIds,
    ...(regionBreakdown && { regionBreakdown }),
  });

  return `/api/playlist/trend/track/${entityIds}?${params}`;
}
